import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.images_1 = new (CouplingImages())('overlayPng', 'graphqlSvg', 'logoSvg', 'noPartyImagePath', 'noPlayerImagePath', 'frodo', 'samwise', 'grayson', 'wayne', 'rosie', 'wendy', 'robPng', 'autumnPng');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var CouplingImagesClass;
function CouplingImages() {
  if (CouplingImagesClass === VOID) {
    class $ {
      constructor(overlayPng, graphqlSvg, logoSvg, noPartyImagePath, noPlayerImagePath, frodo, samwise, grayson, wayne, rosie, wendy, robPng, autumnPng) {
        Companion_getInstance();
        this.overlayPng_1 = overlayPng;
        this.graphqlSvg_1 = graphqlSvg;
        this.logoSvg_1 = logoSvg;
        this.noPartyImagePath_1 = noPartyImagePath;
        this.noPlayerImagePath_1 = noPlayerImagePath;
        this.frodo_1 = frodo;
        this.samwise_1 = samwise;
        this.grayson_1 = grayson;
        this.wayne_1 = wayne;
        this.rosie_1 = rosie;
        this.wendy_1 = wendy;
        this.robPng_1 = robPng;
        this.autumnPng_1 = autumnPng;
      }
      toString() {
        return 'CouplingImages(overlayPng=' + this.overlayPng_1 + ', graphqlSvg=' + this.graphqlSvg_1 + ', logoSvg=' + this.logoSvg_1 + ', noPartyImagePath=' + this.noPartyImagePath_1 + ', noPlayerImagePath=' + this.noPlayerImagePath_1 + ', frodo=' + this.frodo_1 + ', samwise=' + this.samwise_1 + ', grayson=' + this.grayson_1 + ', wayne=' + this.wayne_1 + ', rosie=' + this.rosie_1 + ', wendy=' + this.wendy_1 + ', robPng=' + this.robPng_1 + ', autumnPng=' + this.autumnPng_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.overlayPng_1);
        result = imul(result, 31) + getStringHashCode(this.graphqlSvg_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.logoSvg_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.noPartyImagePath_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.noPlayerImagePath_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.frodo_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.samwise_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.grayson_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.wayne_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.rosie_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.wendy_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.robPng_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.autumnPng_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CouplingImages()))
          return false;
        if (!(this.overlayPng_1 === other.overlayPng_1))
          return false;
        if (!(this.graphqlSvg_1 === other.graphqlSvg_1))
          return false;
        if (!(this.logoSvg_1 === other.logoSvg_1))
          return false;
        if (!(this.noPartyImagePath_1 === other.noPartyImagePath_1))
          return false;
        if (!(this.noPlayerImagePath_1 === other.noPlayerImagePath_1))
          return false;
        if (!(this.frodo_1 === other.frodo_1))
          return false;
        if (!(this.samwise_1 === other.samwise_1))
          return false;
        if (!(this.grayson_1 === other.grayson_1))
          return false;
        if (!(this.wayne_1 === other.wayne_1))
          return false;
        if (!(this.rosie_1 === other.rosie_1))
          return false;
        if (!(this.wendy_1 === other.wendy_1))
          return false;
        if (!(this.robPng_1 === other.robPng_1))
          return false;
        if (!(this.autumnPng_1 === other.autumnPng_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CouplingImages');
    CouplingImagesClass = $;
  }
  return CouplingImagesClass;
}
//region block: exports
export {
  CouplingImages as CouplingImagesci5yi3b0zpw0,
  Companion_getInstance as Companion_getInstance1l5ym9otmdi2n,
};
//endregion

//# sourceMappingURL=CouplingImages.mjs.map
